import { createSelector } from 'reselect';
import type { State } from '../types.tsx';

export const getRemoteState = (state: State) => state.remoteState;
export const getIsLoaded = createSelector(getRemoteState, (remoteState) => remoteState !== null);
